// @ts-nocheck
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

/** @param {{ title: string, children: import('react').ReactNode, onClose: () => void, wide?: boolean }} props */
export default function Drawer({ title, children, onClose, wide = false }) {
  const closeRef = useRef(/** @type {HTMLButtonElement | null} */ (null));
  const panelRef = useRef(/** @type {HTMLElement | null} */ (null));
  useEffect(() => {
    closeRef.current?.focus();
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (/** @type {KeyboardEvent} */ event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        onClose();
        return;
      }
      if (event.key !== 'Tab' || !panelRef.current) return;
      const nodes = panelRef.current.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
      );
      if (!nodes.length) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);
  return createPortal(
    <div className="fixed inset-0 z-40 flex justify-end bg-slate-900/40" role="presentation" onClick={onClose}>
      <aside
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="owner-drawer-title"
        className={`flex h-full w-full flex-col overflow-y-auto bg-white p-5 shadow-xl ${wide ? 'max-w-[720px]' : 'max-w-[560px]'}`}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="mb-4 flex items-start justify-between gap-3">
          <h2 id="owner-drawer-title" className="text-base font-semibold text-slate-900">{title}</h2>
          <button ref={closeRef} type="button" className="text-sm text-[#0F766E]" onClick={onClose}>Close</button>
        </div>
        {children}
      </aside>
    </div>,
    document.body,
  );
}
